module.exports = __webpack_public_path__ + "img/arrow-up-from-dotted-line.4d02557c.svg";